import { NavLink } from "react-router-dom";
import clsx from "clsx";

interface ISideBar {
  SetState: any;
}
interface IEntry {
  path: string;
  content: string;
}
const info: IEntry[] = [
  { path: "/schedule/first", content: "первый" },
  { path: "/schedule/second", content: "второй" },
];

export default function SideBar({ SetState }: ISideBar) {
  return (
    <div
      className="fixed top-0 left-0 w-full h-full bg-black/50 z-20"
      onClick={() => {
        SetState(false);
      }}
    >
      <div
        className="fixed top-0 left-0 w-64 h-screen text-white p-12 overflow-y-auto bg-green-500 transition-all duration-300 ease-linear"
        onClick={(e) => e.stopPropagation()}
      >
        <nav>
          <ul>
            {info.map((entry, _) => {
              return (
                <li>
                  <NavLink
                    to={entry.path}
                    onClick={() => {
                      SetState(false);
                    }}
                    className={({ isActive }): string => {
                      return clsx(
                        { "text-black": isActive },
                        { "text-white": !isActive }
                      );
                    }}
                  >
                    {entry.content}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
}
